import React from 'react'
import Modal from 'react-bootstrap/Modal'
import Spinner from 'react-bootstrap/Spinner'
import I18n from '../../resources/i18n/I18n'

const ValidationEventsErrorModal = ({ showModal, onHideModal, loading }) => {
  return (
    <Modal className="modal" show={showModal} onHide={onHideModal}>
      <Modal.Header closeButton>
        <Modal.Title>{I18n.t('ValidationEventsTitle')}</Modal.Title>
      </Modal.Header>

      <Modal.Body className="d-flex justify-content-center align-items-center">
        {loading ? (
          <Spinner animation="border" variant="primary" />
        ) : (
          <div className="d-flex flex-column align-items-center">{I18n.t('ErrorValidationEventsDescription')}</div>
        )}
      </Modal.Body>
    </Modal>
  )
}

export default ValidationEventsErrorModal
